<template>

<div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Basic Schedule</a>
<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help">   <b-icon icon="question-square-fill" ></b-icon> Help</b-button>
</div>
    </h1>
    
    <div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Basic Table</div> 
<div class="panal-body">


<div class="table-responsive p-3" >
 <table class="table table-hover table-bordered" id="printTableCustom" border="1" >
    <thead class="thead-light" style="font-size: 22px;">
        <tr  class="text-center" >
        <th scope="col" >Saturday</th>
        <th scope="col" >Sunday</th>
        <th scope="col" >Monday</th>
        <th scope="col" >Tuesday</th>
        <th scope="col" >Wedensday</th>
        <th scope="col" >Thursday</th>             
        <th scope="col" >Friday</th>  
        </tr>
    </thead>
    <tbody>
     <tr v-if="empty"><td colspan="12" class="text-danger font-weight-bold"> No Data </td></tr>

        <tr  class="text-center" v-else v-for="item in basicSchedule" v-bind:key="item.Serial" >
           
            <td v-if="item.WeekDay == 'Saturday'"> 
                ( {{item.TypeNameEN}} ) <br> {{item.CourseNameEN}} <br> {{item.StartTime}} To {{item.EndTime}}
            </td>
             <td v-else> 
               
            </td>

            <td v-if="item.WeekDay == 'Sunday'" > 
            <div class="text-primary"> </div>
                 ( {{item.TypeNameEN}} ) <br> {{item.CourseNameEN}} <br> {{item.StartTime}} To {{item.EndTime}}
            </td>
            <td v-else> 
               
            </td>

            <td v-if="item.WeekDay == 'Monday'"> 
                 ( {{item.TypeNameEN}} ) <br> {{item.CourseNameEN}} <br> {{item.StartTime}} To {{item.EndTime}}
            </td>
            <td v-else> 
               
            </td>

            <td v-if="item.WeekDay == 'Tuesday'">
                ( {{item.TypeNameEN}} ) <br> {{item.CourseNameEN}} <br> {{item.StartTime}} To {{item.EndTime}}
            </td>
            <td v-else> 
               
            </td>

            <td v-if="item.WeekDay == 'Wednesday'"> 
                ( {{item.TypeNameEN}} ) <br> {{item.CourseNameEN}} <br> {{item.StartTime}} To {{item.EndTime}}
            </td>                 
            <td v-else> 
               
            </td>

            <td v-if="item.WeekDay == 'Thursday'">    
            <div class="text-primary"> </div>
               ( {{item.TypeNameEN}} ) <br> {{item.CourseNameEN}} <br> {{item.StartTime}} To {{item.EndTime}}
            </td>
            <td v-else> 
               
            </td>
             

            <td v-if="item.WeekDay == 'Friday'">    
            <div class="text-primary"> </div>
               ( {{item.TypeNameEN}} ) <br> {{item.CourseNameEN}} <br> {{item.StartTime}} To {{item.EndTime}}
            </td>
            <td v-else> 
               
            </td>

        </tr>       
        
    </tbody>
   </table>
    
</div>


<div class="float-right col-md-2"> 
    <!-- @click="printBasicSchedule" -->
<button  class="btn btn-success btn-block" v-print="printObj">Print</button>
</div>
<div class="float-right col-md-2"> 

    <router-link to="/Schedule" tag="button" class="btn btn-primary btn-block">View Basic Table</router-link>

    
</div>
<div class="clearfix"></div>



</div>
</div>
</div>
</div>

</div>
</template>
<script>
import BasicSchedule from '../../services/student/studentDataServices'

    export default {
        name: 'BasicSchedule',
        data(){
            return{
                basicSchedule: [],
                 message:'',
                isLoading : true, 
                empty:false,
                printObj: {
                id: "printTableCustom",
                popTitle: 'Student Basic Schedule',
                extraCss: 'https://www.google.com,https://www.google.com',
                extraHead: '<meta http-equiv="Content-Language"content="en-us"/>'
            } 
            }
        }, 
         computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
          mounted(){
        //    this.currenUser.StudentID  // 25096 or 566
           BasicSchedule.getStudentScheduale(this.currenUser.StudentID).then(Response =>{
               this.isLoading = false ;
               this.basicSchedule = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
                //console.log('Basic Schedule => ', Response.data)
           }, error => {
              this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
           // this.printBasicSchedule();
       }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

</style>
